import React, { Component } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import moment from 'moment';
import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFile';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: [{}],
      bpFile: [],
      bpIndex: 0,
      planIndex: 0,
      planFile: [],
      delFiles: [],
    };
  }

  componentWillMount() {
    this.setState({
      project: this.props.data,
    });
  }

  handleBpClick = index => {
    this.setState({
      bpIndex: index,
    });
  };

  handlePlanClick = index => {
    this.setState({
      planIndex: index,
    });
  };

  handleBp = fileList => {
    const { bpIndex, bpFile } = this.state;
    bpFile[bpIndex] = fileList;
    this.setState({ bpFile });
  };

  handlePlan = fileList => {
    const { planIndex, planFile } = this.state;
    planFile[planIndex] = fileList;
    this.setState({ planFile });
  };

  addPro = () => {
    const { project } = this.state;
    project.push({});
    this.setState({
      project,
    });
  };

  formatFile = fileList => {
    const file = [];
    fileList.map(item => {
      const fileItem = {};
      fileItem.uuid = item.uuid;
      fileItem.url = item.url;
      fileItem.size = item.size;
      fileItem.name = item.name;
      fileItem.suffix = item.name.split('.')[1];
      file.push(fileItem);
      return item;
    });
    return file;
  };

  fixFileArr = file => {
    const fileArr = [];
    const fileItem = {};
    if (file) {
      fileItem.uid = file.uuid;
      fileItem.name = file.name;
      fileItem.status = 'done';
      fileItem.url = file.url;
      fileArr.push(fileItem);
    }
    return fileArr;
  };

  fixBpFileArr = fileArr => {
    if (fileArr && fileArr.length > 0) {
      const files = fileArr.map((file, index) => {
        return {
          uid: file.file_id || index,
          name: file.name,
          url: file.url,
          status: 'done',
        };
      });
      fileArr = files;
    }
    return fileArr;
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    const { project, bpFile, planFile } = this.state;
    const projects = [];
    const context = this;
    const projectsInfo = this.props.form.getFieldsValue();
    project.map((item, index) => {
      const projectItem = {};
      projectItem.finance = {};
      let plan = {};
      projectItem.name = projectsInfo[`proName${index}`];
      projectItem.type = projectsInfo[`proType${index}`];

      if (bpFile[index]) {
        projectItem.dpFile = context.formatFile(bpFile[index]);
        projectItem.dpFileUuids = [];
        bpFile[index].map(item1 => {
          projectItem.dpFileUuids.push(item1.uuid);
          return projectItem.dpFileUuids;
        });
      }

      projectItem.finance = {};
      projectItem.finance.money = projectsInfo[`financMoney${index}`];
      projectItem.finance.org = projectsInfo[`financOrg${index}`];
      projectItem.finance.type = +projectsInfo[`financType${index}`];
      projectItem.finance.date = projectsInfo[`financDate${index}`]._d.getTime();
      if (planFile[index]) {
        plan = context.formatFile(planFile[index])[0];
        projectItem.finance.planFileUuid = planFile[index][0].uuid;
      }
      projectItem.finance.plan = plan;
      if (bpFile[index]) {
        projects.push(projectItem);
      }
      return projects;
    });
    this.props.form.validateFields(err => {
      if (!err) {
        handSubmit(projects);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(() => {});
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { project } = this.state;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15, marginTop: '-45px' }}>
          <BackBtn />
        </div>
        <div
          style={{
            background: '#fff',
            height: '50px',
            marginBottom: '15px',
            color: 'rgba(0,0,0,0.85)',
            fontSize: '14px',
            lineHeight: '50px',
            paddingLeft: '24px',
          }}
        >
          项目信息
        </div>
        {project.map((item, index) => {
          const finance = item.finance || {};
          const bpFile = this.fixBpFileArr(item.dpFiles);
          const plan = this.fixFileArr(finance.planFile);
          return (
            <Card key={item.uuid}>
              <Row>
                <Col span={10}>
                  <FormItem label="项目名称" {...ItemLayout}>
                    {getFieldDecorator(`proName${index}`, {
                      rules: [{ required: true, message: '项目名称!' }],
                      initialValue: item.name || '',
                    })(<Input placeholder="项目名称" />)}
                  </FormItem>
                </Col>
                <Col span={10}>
                  <FormItem label="项目类别" {...ItemLayout}>
                    {getFieldDecorator(`proType${index}`, {
                      rules: [{ required: true, message: '请选择组织!' }],
                      initialValue: item.type ? `${item.type}` : '1',
                    })(
                      <Select size="large">
                        <Option key="1" value="1">
                          公司
                        </Option>
                        <Option key="0" value="2">
                          个人
                        </Option>
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={10} className="redStar">
                  <FormItem label="项目BP" {...ItemLayout} className="redStar">
                    <UploadFile
                      type="ghost"
                      handleUpload={this.handleBp}
                      fileList={bpFile}
                      handleClick={() => this.handleBpClick(index)}
                      onRemove={this.fileRemove}
                    />
                  </FormItem>
                </Col>
                <Col span={10}>
                  <FormItem label="获得融资金额" {...ItemLayout}>
                    {getFieldDecorator(`financMoney${index}`, {
                      rules: [{ required: true, message: '请输入融资金额!' }],
                      initialValue: finance.money || '',
                    })(<Input placeholder="获得融资金额" />)}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={10}>
                  <FormItem label="投资机构" {...ItemLayout}>
                    {getFieldDecorator(`financOrg${index}`, {
                      initialValue: finance.org || '',
                    })(<Input placeholder="投资机构" />)}
                  </FormItem>
                </Col>
                <Col span={10}>
                  <FormItem label="获得融资阶段" {...ItemLayout}>
                    {getFieldDecorator(`financType${index}`, {
                      rules: [{ required: true, message: '请选择融资阶段!' }],
                      initialValue: finance.type ? `${finance.type}` : '',
                    })(
                      <Select size="large">
                        <Option key="0" value="0">
                          种子
                        </Option>
                        <Option key="1" value="1">
                          天使
                        </Option>
                        <Option key="2" value="2">
                          pre-A
                        </Option>
                        <Option key="3" value="3">
                          A轮
                        </Option>
                        <Option key="4" value="4">
                          B轮
                        </Option>
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={10}>
                  <FormItem label="获取融资时间" {...ItemLayout}>
                    {getFieldDecorator(`financDate${index}`, {
                      rules: [{ required: true, message: '请输入手机号!' }],
                      initialValue: finance.date ? moment(finance.date) : null,
                    })(<DatePicker style={{ width: '100%' }} />)}
                  </FormItem>
                </Col>

                <Col span={10} className="redStar">
                  <FormItem label="后续融资计划" {...ItemLayout}>
                    <UploadFile
                      type="ghost"
                      handleUpload={this.handlePlan}
                      fileList={plan}
                      handleClick={() => this.handlePlanClick(index)}
                      onRemove={this.fileRemove}
                    />
                  </FormItem>
                </Col>
              </Row>
            </Card>
          );
        })}

        <div style={{ marginBottom: 15, width: '100%', border: '1px dashed #aaa' }}>
          <Button
            icon="plus"
            style={{
              margin: '0 auto',
              display: 'block',
              border: 'none',
              background: 'none',
            }}
            onClick={this.addPro}
          >
            添加
          </Button>
        </div>
        <div style={{ marginBottom: 15 }}>
          <Button icon="save" style={{ marginRight: 10 }} htmlType="submit" type="primary">
            完成
          </Button>
          <Button icon="save" style={{ marginRight: 10 }} htmlType="submit">
            暂存
          </Button>
        </div>
      </Form>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(
  Form.create({ wrappedComponentRef: true })(BaseForm),
);



// WEBPACK FOOTER //
// ./src/components/custom/base/FormProEdit.js